import TurnaroundModel from "@/models/lab/TurnaroundModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TurnaroundCollection extends LabServiceCollection {
  model() {
    return TurnaroundModel;
  }

}
